<template>
  <div
    :class="`box-info-container cursor-pointer ${cor} ${ active ? 'active' : ''}`"
    :style="`max-width: ${larguraMaxima}; grid-column: span ${gridColumnSpan}; grid-row: span ${gridRowSpan};`"
    @click="clickEmit"    
  >
    <header>
      <SGPRowComponent justify="center">
        <SGPColComponent v-if="$slots.topLeft" xs="12" class="top-left">
          <slot name="topLeft"></slot>
        </SGPColComponent>
        <SGPColComponent v-if="$slots.topCenter" xs="10" class="top-center">
          <slot name="topCenter"></slot>
        </SGPColComponent>
        <SGPColComponent v-if="$slots.topRight" xs="12" class="top-right">
          <slot name="topRight"></slot>
        </SGPColComponent>
      </SGPRowComponent>
    </header>
    <div class="content">
      <SGPRowComponent justify="center">
        <SGPColComponent v-if="$slots.contentLeft" class="content-left">
          <slot name="contentLeft"></slot>
        </SGPColComponent>
        <SGPColComponent v-if="$slots.contentCenter" class="content-center">
          <slot name="contentCenter"></slot>
        </SGPColComponent>
        <SGPColComponent v-if="$slots.contentRight" class="content-right">
          <slot name="contentRight"></slot>
        </SGPColComponent>
      </SGPRowComponent>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SGPBoxComponent',

  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    cor: {
      type: String,
      required: false,
      default: 'cinza',
    },
    titulo: {
      type: String,
      required: false,
      default: 'Título'
    },
    subTitulo: {
      type: String,
      required: false,
      default: 'Subtitulo'
    },
    descricao: {
      type: String,
      required: false,
      default: 'Descrição'
    },
    larguraMaxima: {
      type: Number,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Object,
      required: false
    },
    // New props for grid positioning
    gridColumnSpan: {
      type: Number,
      default: 1
    },
    gridRowSpan: {
      type: Number,
      default: 1
    }
  },

  methods: {
    clickEmit() {
      const emitVar = this.value || this.name
      this.$emit('emitBoxClick', emitVar)
    }
  }
}
</script>

<style scoped lang="scss">
  .box-info-container {
    border-radius: 5px;
    width: 100%;
    header, .content { padding: 10px; }

    .content {
      border-top: solid 1px #aaa;
      span {
        display: block;
      }
    }
  }

  .vermelho {
    color: #fff;
    background-color: #df323b;

    .content { 
      border-color: rgba(252, 193, 193, 0.40);
      line-height: 1.1;
    }
  }

  .branco {
    color: #999;
    background-color: #fff;
    .top-center {}
    .content { border-color: rgba(200, 200, 200, .3); }
  }

  .cinza {
    color: #999;
    background-color: rgba(240, 240, 240, .54);
    .top-center {}
    .content { border-color: rgba(200, 200, 200, .3); }
  }
  
  .amarelo {
    color: #222;
    background-color: rgba(255, 241, 216, 0.4);
    .content { border-color: rgba(255, 241, 216, 1); }
  }

  .active {
    .top-center, .content-center {
      color: #df323b;
    }
  }
</style>
